var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70588 13.0249V13.5249H7.11255L7.1954 13.1268L6.70588 13.0249ZM9 2L9.49477 1.92786L8.51049 1.89814L9 2ZM11.916 22L11.4212 22.0721L12.4034 22.1115L11.916 22ZM15.1092 8.03878L15.5831 7.87908L14.6218 7.9273L15.1092 8.03878ZM16.7899 13.0249L16.3161 13.1846L16.4308 13.5249H16.7899V13.0249ZM2 13.5249H6.70588V12.5249H2V13.5249ZM7.1954 13.1268L9.48951 2.10186L8.51049 1.89814L6.21637 12.9231L7.1954 13.1268ZM8.50523 2.07214L11.4212 22.0721L12.4107 21.9279L9.49477 1.92786L8.50523 2.07214ZM12.4034 22.1115L15.5967 8.15026L14.6218 7.9273L11.4286 21.8885L12.4034 22.1115ZM14.6354 8.19849L16.3161 13.1846L17.2637 12.8652L15.5831 7.87908L14.6354 8.19849ZM16.7899 13.5249H22V12.5249H16.7899V13.5249Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.800df424c6f94b2ab3ad897571d6a05b.svg";
export { ForwardRef as ReactComponent };